<template>
    <BreadCrumb PageTitle="Rechargement par KkiaPay" />
    <RechargeKkiaPay/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import RechargeKkiaPay from "@/components/Compte/RechargeKkiaPay.vue";
  
    export default defineComponent({
      name: "RechargeKkiaPayPage",
      components: {
        BreadCrumb,
        RechargeKkiaPay,
      },
    });
  </script>